import type { AbsoluteRoutePathWithId, RelativeRoutePathWithId } from './Domain'
import { useRouteWithId } from './Hook.RouteWithId'

export const useRedirectionWithId = <I>(
    route: AbsoluteRoutePathWithId | RelativeRoutePathWithId,
    idMapper: (input: I) => string
): ((input: I) => void) | void => {
    const routeWithId = useRouteWithId(route)
    return routeWithId ? (i: I) => routeWithId.redirect(idMapper(i)) : undefined
}
